import React, { useContext } from "react";
import {
  Box,
  IconButton,
  Typography,
  Tooltip,
  Avatar,
  useTheme,
} from "@mui/material";
import {
  LightModeOutlined as LightModeIcon,
  DarkModeOutlined as DarkModeIcon,
  NotificationsOutlined as NotificationsIcon,
  SettingsOutlined as SettingsIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../redux/actions/user";
import { useNavigate } from "react-router-dom";
import { ColorModeContext, tokens } from "../../theme";

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/login");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 1.5,
        color: theme.palette.mode === "light" ? colors.grey[900] : colors.grey[100],
        color: colors.grey[900],
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        position: "sticky",
        zIndex: 1100,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          color: theme.palette.mode === "light" ? "black" : "white",
        }}
      >
        ETABLISSEMENT ROSE
      </Typography>

      <Box display="flex" alignItems="center" gap={2}>
        <Tooltip title="Switch Theme">
          <IconButton
            onClick={colorMode.toggleColorMode}
            sx={{
              backgroundColor: colors.primary[400],
              "&:hover": { backgroundColor: colors.primary[300] },
            }}
          >
            {theme.palette.mode === "dark" ? (
              <DarkModeIcon sx={{ color: "white" }} />
            ) : (
              <LightModeIcon sx={{ color: "black" }} />
            )}
          </IconButton>
        </Tooltip>
        <Tooltip title="Logout">
          <IconButton
            onClick={handleLogout}
            sx={{
              backgroundColor: colors.primary[400],
              "&:hover": { backgroundColor: colors.primary[300] },
            }}
          >
            <LogoutIcon sx={{ color: theme.palette.mode === "light" ? "black" : "white" }} />
          </IconButton>
        </Tooltip>

        <Tooltip title={`Logged in as ${user?.name || "Guest"}`}>
          <Avatar
            src="/placeholder.svg"
            alt="User Avatar"
            sx={{
              width: 36,
              height: 36,
              cursor: "pointer",
              "&:hover": { opacity: 0.8 },
            }}
          />
        </Tooltip>
      </Box>
    </Box>
  );
};

export default Topbar;
